import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useSelector } from 'react-redux';
import arrayMutators from 'final-form-arrays';
import { useIntl } from 'react-intl';

import PageBaseProps from 'types/PageBase';
import AdviceStatus from 'types/AdviceStatus';
import FormKeys from 'modules/form/types/FormKeys';
import { FormValidatorWithIntl } from 'types/Form';
import { RepairOrderForm as RepairOrderFormType } from 'types/RepairOrderForm';

import { isModalOpen } from 'modules/basket/selectors';
import ConnectedForm from 'components/ui/ConnectedForm';

import RepairOrderForm from './RepairOrderForm';
import PopupErrorForm from '../Errors/PopupErrorForm';
import { setIn } from 'final-form';

export const validateForm: FormValidatorWithIntl<RepairOrderFormType> = (intl) => ({ proactiveWorks = [] }) => (
  proactiveWorks.reduce((acc, proactiveWork, index) => {
    if (proactiveWork.status === AdviceStatus.PENDING) {
      return setIn(acc, `proactiveWorks[${index}].status`, intl.formatMessage({
        id: 'validation.required',
        defaultMessage: 'Please answer to continue.',
      }));
    }
    return acc;
  }, {})
);

const RepairOrder: React.FC<PageBaseProps> = ({ onNext, ...pageProps }) => {
  const intl = useIntl();

  const isBasketModalOpen = useSelector(isModalOpen);

  const [key, setKey] = React.useState(uuidv4());

  // Use to refresh the form when it has been updated in the basket modal.
  React.useEffect(() => {
    if (!isBasketModalOpen) {
      setKey(uuidv4());
    }
  }, [isBasketModalOpen]);

  return (
    <div className="main-content" key={key}>
      <ConnectedForm
        onSubmit={onNext}
        keepDirtyOnReinitialize
        component={RepairOrderForm}
        validate={validateForm(intl)}
        mutators={{ ...arrayMutators }}
        formKey={FormKeys.REPAIR_ORDER}
        subscription={{ hasValidationErrors: true }}
        errorComponent={<PopupErrorForm errorMessage={{
          id: 'proactiveWorks.mandatoryModal.title',
          defaultMessage: 'You must first answer {count, plural, one {the proactive work} other {all proactive works}} marked with "{mandatory}".',
        }} />}
        {...pageProps}
      />
    </div>
  );
};

export default RepairOrder;
